import type { TFunction } from 'i18next'

const now = new Date()
export const CURRENT_YEAR = now.getFullYear()
export const CURRENT_MONTH = now.getMonth() + 1

export const YEAR_OPTIONS = Array.from({ length: 5 }, (_, i) => CURRENT_YEAR - i)
export function getMonthLabels(t: TFunction): string[] {
  return t('dates.months', { ns: 'common', returnObjects: true }) as string[]
}
export const TAKE_OPTIONS = [5, 10, 15, 20]

export const CHART_COLORS = [
  'var(--chart-1)', 'var(--chart-2)', 'var(--chart-3)', 'var(--chart-4)', 'var(--chart-5)',
  'var(--chart-1)', 'var(--chart-2)', 'var(--chart-3)', 'var(--chart-4)', 'var(--chart-5)',
  'var(--chart-1)', 'var(--chart-2)', 'var(--chart-3)', 'var(--chart-4)', 'var(--chart-5)',
  'var(--chart-1)', 'var(--chart-2)', 'var(--chart-3)', 'var(--chart-4)', 'var(--chart-5)',
]
